var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColorLinkedinIcon = function SvgColorLinkedinIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0077B5",
    d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.66 7.411c0 .785-.591 1.413-1.54 1.413h-.017C6.19 8.824 5.6 8.196 5.6 7.41 5.6 6.611 6.208 6 7.14 6s1.503.61 1.52 1.411M8.48 9.94v8.171H5.761V9.94zm9.808 8.17v-4.685c0-2.51-1.342-3.678-3.131-3.678-1.444 0-2.09.793-2.452 1.35V9.938h-2.72c.036.767 0 8.171 0 8.171h2.72v-4.563c0-.244.018-.488.09-.663.197-.488.644-.993 1.395-.993.985 0 1.378.75 1.378 1.847v4.372z",
    clipRule: "evenodd"
  })));
};
export default SvgColorLinkedinIcon;